module.exports = __webpack_public_path__ + "247d8b6106612dbf91418f550d1515c7.MP3";